import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import dragStart from '@mailobj-browser/front/js/events/types/dragStart.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import dragEnd from '@mailobj-browser/front/js/events/types/dragEnd.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onDragStart = object(listener, {
  type: dragStart,
  passive,
  task: (
    postit
  ) => {
    const { parentNode } = postit
    const { style } = parentNode
    style.setProperty('width', '100%')
    style.setProperty('height', '100%')
  }
})

const onDragEnd = object(listener, {
  type: dragEnd,
  passive,
  task: (
    postit
  ) => {
    const { parentNode } = postit
    parentNode.removeAttribute('style')

    const { dataset, offsetLeft, offsetTop } = postit
    const { uid } = dataset

    const url = href('auth/postit', {
      modify: 1,
      postit_pos_x: offsetLeft,
      postit_pos_y: offsetTop,
      postit_uid: uid
    })

    globals.ea_link_direct(url, 'nodiv_in', null)
  }
})

export default postit => {
  onDragStart.listen(postit)
  onDragEnd.listen(postit)
}
